import { render, staticRenderFns } from "./ProcessStatusRuleList.vue?vue&type=template&id=09cf5428"
import script from "./ProcessStatusRuleList.vue?vue&type=script&lang=js"
export * from "./ProcessStatusRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports